export const maxPeoplePerRoom = 4;
